import resolveImage from '../services/image-loader';

const ImageResolverPlugin = {
  install(Vue, options = {}) {
    Vue.prototype.$loadImage = function (src) {
      let imageUrl = resolveImage(`./${src}`, true);
      return typeof imageUrl === 'string' ? imageUrl : imageUrl?.default;
    };
  },
};

export default ImageResolverPlugin;
